import { render, staticRenderFns } from "./ModuleYoutube.vue?vue&type=template&id=468bd4f3&scoped=true"
import script from "./ModuleYoutube.vue?vue&type=script&lang=js"
export * from "./ModuleYoutube.vue?vue&type=script&lang=js"
import style0 from "./ModuleYoutube.vue?vue&type=style&index=0&id=468bd4f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468bd4f3",
  null
  
)

export default component.exports